<template>
  <v-dialog
    v-model="isOpen"
    max-width="600"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        <div class="columns">
          <div class="column" v-if="isCreate">
            <h2 class="title is-3">Создать аккаунт LeadGid</h2>
          </div>
          <div class="column" v-else>
            <h2 class="title is-3">Изменить аккаунт LeadGid: {{ currentLeadgidAccountName }}</h2>
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-layout row>
          <v-layout column>
            <b-field label="Название">
              <b-input v-model="currentLeadgidAccount.name"></b-input>
            </b-field>

            <b-field label="Leadgid ID">
              <b-input type="number" v-model="currentLeadgidAccount.leadgid_id"></b-input>
            </b-field>

            <b-field label="Токен">
              <b-input v-model="currentLeadgidAccount.token"></b-input>
            </b-field>

            <b-field label="Избранный">
              <b-switch v-model="currentLeadgidAccount.is_favorite">{{currentLeadgidAccount.is_favorite ? 'Да' : 'Нет'}}</b-switch>
            </b-field>

          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" v-if="isCreate" @click="createLeadgidAccount()">Добавить</v-btn>
        <v-btn text color="primary" v-else @click="updateLeadgidAccount()">Обновить</v-btn>
      </v-card-actions>
      <overlay-loader :show="isLoading"></overlay-loader>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';
import { toFormData } from '@/app/shared/services/helpers';

export default {
  name: 'LeadgidAccountDetailsModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {
      currentLeadgidAccountName: '',
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.currentLeadgidAccountName = this.currentLeadgidAccount.name;
      }
    },
  },
  computed: {
    isCreate() {
      return this.currentLeadgidAccount.id == null;
    },
    isLoading: {
      get() {
        return this.$store.getters.GET_LEADGID_ACCOUNT_DETAILS_MODAL_LOADING;
      },
      set(value) {
        this.$store.commit('SET_LEADGID_ACCOUNT_DETAILS_MODAL_LOADING', value);
      }
    },
    isOpen: {
      get() {
        return this.$store.getters.GET_LEADGID_ACCOUNT_DETAILS_MODAL_OPENED;
      },
      set() {
        this.$store.commit('SET_LEADGID_ACCOUNT_DETAILS_MODAL_OPENED', false);
      },
    },
    currentLeadgidAccount: {
      get() {
        return this.$store.getters.GET_CURRENT_LEADGID_ACCOUNT;
      },
      set(value) {
        this.$store.commit("SET_CURRENT_LEADGID_ACCOUNT", value);
      },
    },
  },
  methods: {
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    },
    close() {
      this.currentLeadgidAccount = {}; // Очистка текущего аккаунта
      this.isOpen = false;
    },
    createLeadgidAccount() {
      this.$store.dispatch('CREATE_LEADGID_ACCOUNT', toFormData(this.currentLeadgidAccount))
        .then(() => {
          this.$toast.success("Leadgid аккаунт создан!");
        })
        .catch((error) => {
          this.$toast.error(error);
        }).finally(() => {
        this.close();
      });
    },
    updateLeadgidAccount() {
      let data = {
        id: this.currentLeadgidAccount.id,
        form: toFormData(this.currentLeadgidAccount)
      }
      this.$store.dispatch('UPDATE_LEADGID_ACCOUNT', data)
        .then(() => {
          this.$toast.success("Leadgid аккаунт успешно изменен");
          this.close();
        })
        .catch(() => {
          this.$toast.error("Ошибка при изменении аккаунта");
        });
    }
  },
};
</script>
